import React from 'react'
import { Card, Divider, Image, Segment } from 'semantic-ui-react'
import {extraImageUrl} from '../../utility/Global'

export const Motes = () => (
    <Card fluid className='motes-container'>
        <Card.Content>
        <Card.Description>

                <Image src={extraImageUrl('motes')} rounded centered />
                <Divider />
                <Image src={extraImageUrl('motes_2')} rounded centered />
                <Divider />
                <Image src={extraImageUrl('motes_3')} rounded centered />

        </Card.Description>
        </Card.Content>
    </Card>
)
